module.exports = __webpack_public_path__ + "static/media/hyundai-go-drive.1c6aa901.png";